// extracted by mini-css-extract-plugin
export default {"Container":"textInput__Container__EeRAZ","Input":"textInput__Input__BQDgR","Label":"textInput__Label__CgeMA","Hover":"textInput__Hover__nILjF"};